<app-admin-sidebar></app-admin-sidebar>
<app-adminheader></app-adminheader>
<div class="dash" *ngIf="userCustomer">
  <div class="users-acoordion">
    <div class="dash-users-top1">
      <a [ngClass]="{ active: selectedUserType == 'Customers' }" (click)="UserType('Customers')">Customers</a>
      <a [ngClass]="{ active: selectedUserType == 'truck-owners' }" (click)="UserType('truck-owners')">Truck Owners</a>
      <a [ngClass]="{ active: selectedUserType == 'driver' }" (click)="UserType('driver')">Driver</a>
      <a [ngClass]="{ active: selectedUserType == 'admin' }" (click)="UserType('admin')">Admin
      </a>
      <!-- <a
        [ngClass]="{ active: selectedUserType == 'employees' }"
        (click)="UserType('employees')"
        >S9 Employees
      </a> -->
      <button type="button" *ngIf="searchButton" class="button search-btn fixed-btn" (click)="openSearch()">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input class="search" placeholder="Mobile Number" id="searchtripID" minlength="10" maxlength="10" #newItem
          (keypress)="validateNumber($event)" (keyup)="onInputChangeCustomer(newItem)"
          (keyup.enter)="isInputValid && customersearch(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_btn" class="search_number"
          (click)="customersearch(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <button type="button" *ngIf="clear_btn" class="search_number1" (click)="resetUsersList(newItem.value)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="row to_container" *ngIf="!customerdata?.length && !customerloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div [class.spinner]="customerloading"></div>

  <div class="mat-elevation-z8" *ngIf="customerdata?.length">
    <table mat-table [dataSource]="customerUserList">
      <ng-container matColumnDef="uid">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>UID</th>
        <td class="driver-view" style="text-decoration: underline" mat-cell *matCellDef="let element"
          (click)="viewCustomers(element)">
          {{ element.user_id }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.username }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mobile">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Mobile</th>
        <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
      </ng-container>

      <ng-container matColumnDef="Login">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Last Login</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element.last_login | date : "dd-MM-yyyy" }} -->
          <ng-container *ngIf="element.login_status != 'inactive'">
            {{ element.last_login | date : "dd-MM-yyyy" }}
          </ng-container>
        </td>
      </ng-container>

      <ng-container matColumnDef="Trips">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Trips</th>
        <td mat-cell *matCellDef="let element">
          {{ element.tripsCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="CustomerType">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>
          Customer Type
        </th>
        <td mat-cell *matCellDef="let element" class="ex3" (click)="openpopup(element)">
          {{ element.user_type }}
        </td>
      </ng-container>
      <ng-container matColumnDef="Status">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          {{ element.login_status }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="pagination" *ngIf="paginationCustomer">
      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button class="btn" [disabled]="fetch_page === 1" (click)="pagination('-1')">
          <!-- Left Arrow Icon -->
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        <button class="btn" [disabled]="fetch_page === 1" (click)="pagination('first')">
          <!-- Go to First Page Icon -->
          <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
        </button>

        <div class="pages">
          <a class="page">{{ fetch_page }}</a>
        </div>

        <button class="btn" [disabled]="fetch_page === last_page" (click)="pagination('last')">
          <!-- Go to Last Page Icon -->
          <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
        </button>

        <button class="btn" [disabled]="fetch_page === last_page" (click)="pagination('1')">
          <!-- Right Arrow Icon -->
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Truck Owners -->

<div class="dash" *ngIf="userTruckOwner">
  <div [class.spinner]="truckownerloading"></div>

  <div class="users-acoordion">
    <div class="dash-users-top1">
      <a [ngClass]="{ active: selectedUserType == 'Customers' }" (click)="UserType('Customers')">Customers</a>
      <a [ngClass]="{ active: selectedUserType == 'truck-owners' }" (click)="UserType('truck-owners')">Truck Owners</a>
      <a [ngClass]="{ active: selectedUserType == 'driver' }" (click)="UserType('driver')">Driver</a>
      <a [ngClass]="{ active: selectedUserType == 'admin' }" (click)="UserType('admin')">Admin
      </a>
      <!-- <a
        [ngClass]="{ active: selectedUserType == 'employees' }"
        (click)="UserType('employees')"
        >S9 Employees
      </a> -->
      <button type="button" *ngIf="searchButton" class="button search-btn fixed-btn" (click)="openSearch()">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input class="search" placeholder="Mobile Number" id="searchtripID" minlength="10" maxlength="10" #newItem
          (keypress)="validateNumber($event)" (keyup)="onInputChangeTO(newItem)"
          (keyup.enter)="isInputValid && searchTO(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_btn" class="search_number" (click)="searchTO(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>

        <button type="button" *ngIf="clear_btn" class="search_number1" (click)="resetTOList(newItem.value)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="row to_container" *ngIf="TruckOwner && !truckownerloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div class="mat-elevation-z8" *ngIf="truckOwnerData">
    <table mat-table [dataSource]="truckOwnerUserList">
      <!-- Position Column -->
      <ng-container matColumnDef="ID">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>UID</th>
        <td mat-cell class="text1" *matCellDef="let element" (click)="viewTruckOwner(element)">
          {{ element.registerInfo[0]?.truckowner_id }}
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">{{ element.username }}</td>
      </ng-container>

      <!-- Mobile Column -->
      <ng-container matColumnDef="mobile">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Mobile</th>
        <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
      </ng-container>

      <!-- Login Column -->
      <ng-container matColumnDef="Login">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Last Login</th>
        <td mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.registerInfo[0].truckowner_status != 'rejected'">
            {{ element.last_login | date : "dd-MM-yyyy" }}
          </ng-container>
        </td>
      </ng-container>

      <!-- Customer Type Column -->
      <ng-container matColumnDef="Trips">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Trips</th>
        <td mat-cell *matCellDef="let element">{{ element.tripsCount }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element" [ngClass]="{
            'status-approved': element.login_status === 'active',
            'status-rejected': element.login_status === 'inactive'
          }">
          {{ element.login_status === "active" ? "Approved" : "Rejected" }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedTruckColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedTruckColumns"></tr>
    </table>

    <div class="pagination" *ngIf="paginationTO">
      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button class="btn" [disabled]="truck_fetch_page == 1" (click)="truckOwnerpagination('-1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button class="btn" [disabled]="truck_fetch_page == 1" (click)="truckOwnerpagination('first')">
          <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
        </button>
        <div class="pages">
          <a class="page" *ngIf="truck_fetch_page > 0">{{
            truck_fetch_page
            }}</a>
        </div>
        <button class="btn" [disabled]="last_page == truck_fetch_page" (click)="truckOwnerpagination('last')">
          <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
        </button>
        <button class="btn" [disabled]="last_page == truck_fetch_page" (click)="truckOwnerpagination('1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Driver -->

<div class="dash" *ngIf="userDriver">
  <div [class.spinner]="driverloading"></div>
  <div class="users-acoordion">
    <div class="dash-users-top1">
      <a [ngClass]="{ active: selectedUserType == 'Customers' }" (click)="UserType('Customers')">Customers</a>
      <a [ngClass]="{ active: selectedUserType == 'truck-owners' }" (click)="UserType('truck-owners')">Truck Owners</a>
      <a [ngClass]="{ active: selectedUserType == 'driver' }" (click)="UserType('driver')">Driver</a>
      <a [ngClass]="{ active: selectedUserType == 'admin' }" (click)="UserType('admin')">Admin
      </a>
      <!-- <a
        [ngClass]="{ active: selectedUserType == 'employees' }"
        (click)="UserType('employees')"
        >S9 Employees
      </a> -->
      <button type="button" *ngIf="searchButton" class="button search-btn fixed-btn" (click)="openSearch()">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input class="search" placeholder="Mobile Number" id="searchtripID" minlength="10" maxlength="10" #newItem
          (keypress)="validateNumber($event)" (keyup)="onInputChangeDriver(newItem)"
          (keyup.enter)="isInputValid && searchDriver(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_btn" class="search_number"
          (click)="searchDriver(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>

        <button type="button" *ngIf="clear_btn" class="search_number1" (click)="resetDriverList(newItem.value)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  <div class="row to_container" *ngIf="Drivers && !driverloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>
  <div class="mat-elevation-z8" *ngIf="DriversData">
    <table mat-table [dataSource]="driverUserList">
      <!-- Position Column -->
      <ng-container matColumnDef="ID">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>UID</th>
        <td mat-cell class="text1" *matCellDef="let element" (click)="viewDrivers(element)">
          {{ element.driver_id }}
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="name">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.loginInfo?.username }}
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="email">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">
          {{ element.loginInfo?.email }}
        </td>
      </ng-container>

      <!-- Mobile Column -->
      <ng-container matColumnDef="mobile">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Mobile</th>
        <td mat-cell *matCellDef="let element">
          {{ element.loginInfo?.mobile }}
        </td>
      </ng-container>

      <!-- Login Column -->
      <ng-container matColumnDef="Login">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Last Login</th>
        <td mat-cell *matCellDef="let element">
          <!-- {{ element. element.last_login | date : "dd-MM-yyyy" }} -->
          <ng-container *ngIf="element.driver_status != 'rejected'">
            {{ element.loginInfo?.last_login | date : "dd-MM-yyyy" }}
          </ng-container>
        </td>
      </ng-container>
      <!-- Trips Column -->
      <ng-container matColumnDef="Trips">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Trips</th>
        <td mat-cell *matCellDef="let element">{{ element.tripsCount }}</td>
      </ng-container>
      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element" [ngClass]="{
            'status-approved': element.loginInfo?.login_status === 'active',
            'status-rejected': element.loginInfo?.login_status === 'inactive' && element.driver_status !== 'requested',
            'status-requested': element.loginInfo?.login_status === 'inactive' && element.driver_status === 'requested'
          }">
          {{ element.loginInfo?.login_status === "active" ? "Approved" : (element.loginInfo?.login_status === "inactive" && element.driver_status === "requested" ? "Requested" : "Rejected") }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedDriverColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedDriverColumns"></tr>
    </table>
    <div class="pagination" *ngIf="paginationDriver">
      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button class="btn" [disabled]="dr_fetch_page == 1" (click)="paginationDR('-1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button class="btn" [disabled]="dr_fetch_page == 1" (click)="paginationDR('first')">
          <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
        </button>
        <div class="pages">
          <a class="page" *ngIf="dr_fetch_page > 0">{{ dr_fetch_page }}</a>
        </div>
        <button class="btn" [disabled]="last_page == dr_fetch_page" (click)="paginationDR('last')">
          <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
        </button>
        <button class="btn" [disabled]="last_page == dr_fetch_page" (click)="paginationDR('1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Admin -->

<div class="dash" *ngIf="userAdmin">
  <div [class.spinner]="adminloading"></div>
  <div class="users-acoordion">
    <div class="dash-users-top1">
      <a [ngClass]="{ active: selectedUserType == 'Customers' }" (click)="UserType('Customers')">Customers</a>
      <a [ngClass]="{ active: selectedUserType == 'truck-owners' }" (click)="UserType('truck-owners')">Truck Owners</a>
      <a [ngClass]="{ active: selectedUserType == 'driver' }" (click)="UserType('driver')">Driver</a>
      <a [ngClass]="{ active: selectedUserType == 'admin' }" (click)="UserType('admin')">Admin
      </a>
      <!-- <a
        [ngClass]="{ active: selectedUserType == 'employees' }"
        (click)="UserType('employees')"
        >S9 Employees
      </a> -->
      <button type="button" class="button buttonBlue fixed-btn" (click)="AddLogin(selectedType)">
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Add
      </button>
      <div class="search_toggle">
        <button type="button" *ngIf="searchButton" class="button search-btn fixed-btn" (click)="openSearch()">
          <img src="../../../assets/img/search-white.svg" />
        </button>
        <div *ngIf="toggleSearch" class="search_toggle">
          <input class="search pl-2" placeholder="User Name" id="searchAdminName" style="text-transform: capitalize"
            #newItem (keyup)="onInputChangeAdmin(newItem.value)"
            (keyup.enter)="isInputValid && search(newItem.value)" />
          <button [disabled]="!isInputValid" *ngIf="search_btn" class="search_number" style="text-transform: capitalize"
            (click)="search(newItem.value)">
            <img src="../../../assets/img/search-white.svg" />
          </button>

          <button type="button" *ngIf="clear_btn" class="search_number1" (click)="resetadminList(newItem.value)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
              <path
                d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
    <div class="row to_container" *ngIf="Admin && !adminloading">
      <h4 class="error_msg">No Records Found.</h4>
    </div>
    <div class="mat-elevation-z8" *ngIf="AdminData">
      <table mat-table [dataSource]="adminUserList">
        <!-- Position Column -->
        <ng-container matColumnDef="eID">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>EID</th>
          <td mat-cell class="text1" *matCellDef="let element" (click)="viewAdmin(element)">
            {{ element.adminRegisterDetails?.employee_id }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="username">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>Username</th>
          <td mat-cell *matCellDef="let element">
            {{ element.username }}
          </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="mobile">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>mobile</th>
          <td mat-cell *matCellDef="let element">
            {{ element.mobile }}
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>name</th>
          <td mat-cell *matCellDef="let element">{{ element.adminRegisterDetails?.name }}</td>
        </ng-container>

        <!-- Role -->
        <ng-container matColumnDef="role">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>
            Role
          </th>
          <td mat-cell *matCellDef="let element">{{ element.adminRegisterDetails?.role }}</td>
        </ng-container>

        <!-- SMS Column -->
        <ng-container matColumnDef="sms">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>SMS</th>
          <td mat-cell *matCellDef="let element">
            <span [style.color]="element.adminRegisterDetails?.is_sms_enabled ? 'green' : 'grey'"
              style="font-weight: 600;">
              {{ element.adminRegisterDetails?.is_sms_enabled ? 'Enabled' : 'Disabled' }}
            </span>
          </td>
        </ng-container>

        <!-- Login Column -->
        <ng-container matColumnDef="resetpassword">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>
            Reset Password
          </th>
          <td style="text-decoration: underline" mat-cell *matCellDef="let element" (click)="resetPassword(element)">
            Reset
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th class="driver-th" mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            <span [style.color]="element.adminRegisterDetails?.is_active !== false ? 'green' : 'red'"
              style="font-weight: 600;">
              {{ element.adminRegisterDetails?.is_active !== false ? 'Active' : 'Deactivated' }}
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="dispalyedAdminColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: dispalyedAdminColumns"></tr>
      </table>
      <div class="pagination" *ngIf="paginationAdmin">
        <div *ngIf="last_page && last_page > 1" class="pagination">
          <button class="btn" [disabled]="admin_fetch_page == 1" (click)="adminpagination('-1')">
            <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button class="btn" [disabled]="admin_fetch_page == 1" (click)="adminpagination('first')">
            <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
          </button>
          <div class="pages">
            <a class="page" *ngIf="admin_fetch_page > 0">{{
              admin_fetch_page
              }}</a>
          </div>
          <button class="btn" [disabled]="last_page == admin_fetch_page" (click)="adminpagination('last')">
            <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
          </button>
          <button class="btn" [disabled]="last_page == admin_fetch_page" (click)="adminpagination('1')">
            <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2">
              <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- s9 Employees -->

<div class="dash" *ngIf="userEmployees">
  <div class="users-acoordion">
    <div class="dash-users-top1">
      <a [ngClass]="{ active: selectedUserType == 'Customers' }" (click)="UserType('Customers')">Customers</a>
      <a [ngClass]="{ active: selectedUserType == 'truck-owners' }" (click)="UserType('truck-owners')">Truck Owners</a>
      <a [ngClass]="{ active: selectedUserType == 'driver' }" (click)="UserType('driver')">Driver</a>
      <a [ngClass]="{ active: selectedUserType == 'admin' }" (click)="UserType('admin')">Admin
      </a>
      <!-- <a
        [ngClass]="{ active: selectedUserType == 'employees' }"
        (click)="UserType('employees')"
        >S9 Employees
      </a> -->
      <button type="button" *ngIf="employeeCreate" class="button buttonBlue fixed-btn"
        (click)="CreateEmployeeLogin(selectedType)">
        <img class="trucks-head-img" src="../../../assets/img/plus-white.svg" />
        Create Employee Login
      </button>
      <button type="button" *ngIf="searchButton" class="button search-btn fixed-btn" (click)="openSearchEmployee()">
        <img src="../../../assets/img/search-white.svg" />
      </button>
      <div *ngIf="toggleSearch" class="search_toggle">
        <input class="search pl-2" placeholder="User Name" id="searchEmployeeName" style="text-transform: capitalize"
          #newItem (keyup)="onInputChangeEmployee(newItem.value)"
          (keyup.enter)="isInputValid && searchEmployee(newItem.value)" />
        <button [disabled]="!isInputValid" *ngIf="search_btn" class="search_number"
          (click)="searchEmployee(newItem.value)">
          <img src="../../../assets/img/search-white.svg" />
        </button>

        <button type="button" *ngIf="clear_btn" class="search_number1" (click)="resetEmployeeList(newItem.value)">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor">
            <path
              d="M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" />
          </svg>
        </button>
      </div>
    </div>
  </div>

  <div class="row to_container" *ngIf="s9Employee && !truckownerloading">
    <h4 class="error_msg">No Records Found.</h4>
  </div>

  <div class="mat-elevation-z8" *ngIf="EmployeesData">
    <table mat-table [dataSource]="employeeUserList">
      <!-- Position Column -->
      <ng-container matColumnDef="eid">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>EID</th>
        <td mat-cell class="text1" *matCellDef="let element" (click)="viewEmployee(element)">
          {{ element.adminRegisterDetails.employee_id }}
        </td>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="username">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.username }}
        </td>
      </ng-container>

      <!-- Email Column -->
      <ng-container matColumnDef="mobile">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Mobile</th>
        <td mat-cell *matCellDef="let element">
          {{ element.mobile }}
        </td>
      </ng-container>

      <!-- Mobile Column -->
      <ng-container matColumnDef="email">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <!-- Login Column -->
      <ng-container matColumnDef="resetpassword">
        <th class="driver-th" mat-header-cell *matHeaderCellDef>Role</th>
        <td mat-cell *matCellDef="let element">role</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="dispalyedEmployeeColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: dispalyedEmployeeColumns"></tr>
    </table>
    <div *ngIf="employeePagination">
      <div *ngIf="last_page && last_page > 1" class="pagination">
        <button class="btn" [disabled]="employee_fetch_page == 1" (click)="employeepagination('-1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button class="btn" [disabled]="employee_fetch_page == 1" (click)="employeepagination('first')">
          <img src="../../../assets/img/pagination-left.svg" alt="" class="btn--icon" />
        </button>
        <div class="pages">
          <a class="page" *ngIf="employee_fetch_page > 0">{{
            employee_fetch_page
            }}</a>
        </div>
        <button class="btn" [disabled]="last_page == employee_fetch_page" (click)="employeepagination('last')">
          <img src="../../../assets/img/pagination-right.svg" alt="" class="btn--icon" />
        </button>
        <button class="btn" [disabled]="last_page == employee_fetch_page" (click)="employeepagination('1')">
          <svg xmlns="http://www.w3.org/2000/svg" class="btn--icon" fill="none" viewBox="0 0 24 24"
            stroke="currentColor" stroke-width="2">
            <path stroke-linecap=" round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>